const filtersElementDesktop = document.querySelector('.facet-main__wrapper-desktop')

export class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.filtersElementDesktop = document.querySelector('.facet-main__wrapper-desktop');
    this.filterElementSearch = document.getElementById('main-collection-filters');

    // dropdown
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle?.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle?.addEventListener('focusout', this.onElementout.bind(this));
    this.mainDetailsToggle?.addEventListener('toggle', this.onToggle.bind(this));

    // mega menu
    this.mainMegaMenu = this.querySelector('.mega-menu');
    this.mainMegaMenuToggle = this.mainMegaMenu?.querySelector('.header__menu-item');
    this.mainMegaMenuContent = this.mainMegaMenuToggle?.nextElementSibling;

    this.mainMegaMenuToggle?.addEventListener('mouseleave', this.onElementout.bind(this), false);
    this.mainMegaMenuContent?.addEventListener('mouseleave', this.onElementout.bind(this), false);
    this.mainMegaMenuToggle?.addEventListener('mouseover', this.onToggle.bind(this), false);
  }

  onElementout(event) {
    setTimeout(() => {
      if (event.type == 'focusout') {
        if (!this.contains(document.activeElement)) this.close(event);
      } else {
        this.close(event);
      }
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainMegaMenu.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  open() {
    this.mainMegaMenu?.setAttribute('open', '');
    this.mainMegaMenuToggle?.setAttribute('aria-expanded', true);
    if (this.filtersElementDesktop) {
      this.filtersElementDesktop.classList.add('display_none');
    }
    if (this.filterElementSearch) {
      this.filterElementSearch.classList.add('display_none');
    }
  }

  close(event) {
    if (event) {
      if (event.type == 'focusout') {
        this.mainDetailsToggle?.removeAttribute('open');
        this.mainDetailsToggle?.querySelector('summary').setAttribute('aria-expanded', false);
      };

      let toElement = event.toElement || event.relatedTarget;

      if (toElement != this.mainMegaMenuContent) {
        this.mainMegaMenu?.removeAttribute('open');
        this.mainMegaMenuToggle?.setAttribute('aria-expanded', false);
        if (this.filtersElementDesktop) {
         this.filtersElementDesktop.classList.remove('display_none');
      }
        if (this.filterElementSearch) {
         this.filterElementSearch.classList.remove('display_none');
      }
      }
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

export class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainMegaMenu?.hasAttribute('open');

    this.open();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

export class HeaderDropdown extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-dropdown', HeaderDropdown);